import { Swiper as SliderContainer, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
// @interfaces
import styles from '../styles/pages/estimation/CompensationTips.module.css';
import "swiper/css";
import "swiper/css/pagination";


const CompensationTips: React.FC = () => {

  const tips = [
    {
      name: 'Calculate your carbon footprint',
      description: 'Your flight causes carbon emissions to be released into the atmosphere. These gases are causing climate change. '
    },
    {
      name: 'Offset through climate projects',
      description: 'Compensate for emissions by making a positive impact on the environment somewhere else, by investing in climate projects that remove carbon from the atmosphere or avoid emissions.'
    },
    {
      name: 'Track your offset',
      description: ' Directly trace the positive impact you’re making. A summary of your contribution and the supported projects will go straight to your email inbox.'
    }
  ];

  return (
    <SliderContainer
      modules={[Pagination]}
      pagination={{ clickable: true }}
      className={styles.carouselContainer}
    >
      {tips.map((tip: any, index: number) => {
        return (
          <SwiperSlide
            className={styles.carouselItem}
            key={index}
          >
            <div
              className={styles.carouselImg}
            >
              <p className={styles.tipName}>{tip.name}</p>
              <p className={styles.tipDescription}>{tip.description}</p>
            </div>
          </SwiperSlide>
        );
      })}
    </SliderContainer>
  )
};

export default CompensationTips;
